<style lang="scss">
    .tour {
        z-index: 1046 !important;
        padding: 5px;
        font-family: "Poppins";
        min-width: 270px;
        .popover-navigation {
            padding: 5px !important;
            display: flex;
            justify-content: space-between;
            .btn {
                &, &:hover {
                  color: white !important;
                }
                min-width: 50px;
                height: 38px;
                margin: 0;
                padding: 7px 16px;
            }
            .prev-button, .next-button {
                background-color: #8f40b0;
            }
            .next-button {
                border-left: 1px solid #722a86;
            }
            .end-button {
                margin-left: 10px;
            }
        }
        a {
            color: #8f40b0;
        }
        &.left {
            .arrow {
                border-left-color: #fff;
                &:after {
                    display: none;
                }
            }
        }
    }
    .tour-backdrop {
        z-index: 1045 !important;
    }
</style>

<template>
    <div id="infinityTour"></div>
</template>

<script>

    export default {
        created() {
          /* To prevent the new Bootstrap 3.4.1 sanitization from removing tour navigation buttons */
          $.fn.popover.Constructor.DEFAULTS.whiteList.button = ['data-role']
        },
        mounted() {
            setTimeout(() => {
                if (this.userConfigs.length > 0) {
                    this.setUpMainTour()
                } else if (!window.localStorage.getItem('hideInfinityTour')) {
                    this.setUpStarterTour()
                }
            }, 1000)
        },
        name: 'infinity-tour',
        data() {
            return {
                tour: null,
                currentTour: null,
                callbacks: {
                    onPreviousStep: this.previousStepCallback,
                    onNextStep: this.nextStepCallback
                }
            }
        },
        computed: {
            userConfigs() {
                return this.$store.state.userConfigs
            },
            configPanelOpen() {
                return this.$store.state.dismissConfigOverlay
            },
            mobile() {
                return this.$store.state.viewPortWidth <= 720
            },
        },
        methods: {
            setUpStarterTour() {
                if (this.mobile) {
                    return
                }

                this.currentTour = 'starter'
                let steps = this.getStarterTourSteps()
                let vm = this

                this.tour = new Tour({
                    backdrop: true,
                    container: "#infinityTour",
                    backdropContainer: "#infinityTour",
                    steps,
                    template: "<div class='popover tour'><div class='arrow'></div>" +
                                "<h3 class='popover-title'></h3>" +
                                "<div class='popover-content'></div>" +
                                "<div class='popover-navigation'>" +
                                    "<div class='btn-group'>" +
                                        "<button class='prev-button btn' data-role='prev'>« Prev</button>" +
                                        "<button class='next-button btn' data-role='next'>Next »</button>" +
                                    "</div>" +
                                    "<button class='end-button btn btn-default' data-role='end'>End tour</button>" +
                                "</div>" +
                              "</div>",
                    onEnd: function(tour) {
                        window.localStorage.setItem('hideInfinityTour', true)
                        vm.$store.commit("showTour", {show: false})
                    }
                })

                this.tour.init()

                this.$store.commit("showTour", {show: true})
            },
            setUpMainTour() {
                this.currentTour = 'main'

                let steps = this.getMainTourSteps()
                let vm = this

                this.tour = new Tour({
                    steps,
                    container: ".customise-panel",
                    backdrop: true,
                    backdropContainer: ".customise-panel",
                    template: "<div class='popover tour'><div class='arrow'></div>" +
                                "<h3 class='popover-title'></h3>" +
                                "<div class='popover-content'></div>" +
                                "<div class='popover-navigation'>" +
                                    "<div class='btn-group'>" +
                                        "<button class='prev-button btn' data-role='prev'>« Prev</button>" +
                                        "<button class='next-button btn' data-role='next'>Next »</button>" +
                                    "</div>" +
                                    "<button class='end-button btn btn-default' data-role='end'>End tour</button>" +
                                "</div>" +
                              "</div>",
                    onNext: function(tour) {
                        let nextStep = tour.getStep(tour.getCurrentStep() + 1)
                        vm.nextOrPrevStep(nextStep)

                    },
                    onPrev: function(tour) {
                        if (tour.getCurrentStep() <= 1) {
                            return
                        }

                        let prevStep = tour.getStep(tour.getCurrentStep() - 1)
                        vm.nextOrPrevStep(prevStep)
                    },
                    onEnd: function(tour) {
                        vm.$store.commit("showTour", {show: false})
                    }
                })

                this.tour.init()

                // Start the tour automatically if this.$route.query.tour
                if (!this.mobile && this.$route.query.tour) {
                    if (!this.configPanelOpen) {
                        this.$store.commit('dismissConfigOverlay')
                    }
                    this.$store.commit("showTour", {show: true})
                }

            },
            nextOrPrevStep(step) {
                if (!step || $(step.element).position() == undefined) {
                    return
                }

                let position = $(step.element)[0].offsetTop - 100
                this.scrollToElementInTour(position)
            },
            scrollToElementInTour(position) {
                $(".customise-body").animate({scrollTop: position})
            },
            getStarterTourSteps() {
                let vm = this

                let steps = [
                    {
                        orphan: true,
                        content: "Welcome to your Infinity Store, the world's most powerful and customizable beat store.<p></p><strong>Looks like you're new here! </strong>Would you like to take a tour to get to know all the new features? <p></p><strong>PLEASE NOTE: Only you can see this tour, your customers won't be able to.</strong>",
                        template: "<div class='popover tour'><div class='arrow'></div>" +
                                        "<h3 class='popover-title'></h3>" +
                                        "<div class='popover-content'></div>" +
                                        "<div class='popover-navigation'>" +
                                        "<button class='next-button btn' data-role='next'>Start Tour</button>" +
                                        "<button class='end-button btn btn-default' data-role='end'>No thanks</button>" +
                                        "</div>" +
                                        "</div>"
                    },
                    {
                        element: "#configPanelToggleButton",
                        content: "You are viewing a default configuration. A configuration is like a collection of settings for a particular store, and you can have as many configurations as you want! <p></p>Let’s create your first configuration. You can access the configuration panel by clicking this tog.",
                        placement: "left auto",
                        backdropPadding: 5,
                        onNext: function(tour) {
                            if (!vm.$store.state.dismissConfigOverlay) {
                                vm.$store.commit('dismissConfigOverlay')

                                if (vm.mobile) {
                                    tour.end()
                                }
                            }
                        }
                    },
                    {
                        element: "#newConfigButton",
                        container: ".customise-panel",
                        backdropContainer: ".customise-panel",
                        orphan: true,
                        content: "Click here to create your first configuration.",
                        placement: "bottom auto",
                        backdropPadding: 10,
                        template: "<div class='popover tour'><div class='arrow'></div>" +
                                    "<h3 class='popover-title'></h3>" +
                                    "<div class='popover-content'></div>" +
                                    "<div class='popover-navigation'>" +
                                    "<div class='btn-group'>" +
                                    "<button class='prev-button btn' data-role='prev'>« Prev</button>" +
                                    "</div>" +
                                    "<button class='end-button btn btn-default' data-role='end'>End tour</button>" +
                                    "</div>" +
                                    "</div>",
                        onShow: function(tour) {
                            $("#newConfigButton").one("click", () => {
                                tour.end()
                            })
                        },
                        onPrev: function() {
                            if (vm.$store.state.dismissConfigOverlay) {
                                vm.$store.commit('dismissConfigOverlay')
                            }
                        }
                    },
                ]

                return steps
            },
            getMainTourSteps() {
                let vm = this

                let steps = [
                    {
                        element: "#generalTab",
                        orphan: true,
                        content: "You now have a configuration! Let’s start customising it. You have 4 tabs within your configuration panel, let’s start in General.",
                        placement: "right auto",
                        backdropPadding: {top: 10, bottom: 10, left: 40, right: 0},
                        onShow: function() {
                            vm.$store.commit("changeActiveConfigPanel", {panel: 'general'})
                        }
                    },
                    {
                        element: "#defaultToggle",
                        content: `By setting your configuration to Default, you are choosing the store configuration that will display when you visit <a href='${ab.baseUrl}'>${ab.baseUrl}</a>. You can only have one default configuration. <p></p>We recommend leaving the default configuration looking like a full website as that is what people will see when they visit your URL in the browser. If you want to create a more minimal beat store for embedding on your website, you can create a new configuration for that later.`,
                        placement: "left auto",
                        backdropPadding: 5
                    },
                    {
                        element: "#addLogoSection",
                        content: "You can add your own logo right here.",
                        placement: "left auto",
                    },
                    {
                        element: "#addHeroSection",
                        content: "You can also add a custom hero image. You can choose what pages you want the hero image to display on later.",
                        placement: "left auto",
                    },
                    {
                        element: "#heroTitleSection",
                        content: "Customize the title which appears in your hero.",
                        placement: "top auto",
                        onNext: function() {
                            // vm.$store.commit("changeActiveConfigPanel", {panel: 'styles'})
                            vm.scrollToElementInTour(1000)
                        }
                    },
                    {
                        element: "#highlightedLicenseSection",
                        content: "Choose a license to highlight and you can customize the colors later. This will be the first license that appears in your licenses carousel.",
                        placement: "left auto",
                        onNext: function() {
                            vm.$store.commit("changeActiveConfigPanel", {panel: 'styles'})
                            vm.scrollToElementInTour(0)
                        }
                    },
                    {
                        element: "#stylesTab",
                        content: "The styles panel is where you can customize the colors and look of your store.",
                        placement: "right auto",
                        backdropPadding: {top: 10, bottom: 10, left: 40, right: 0},
                        onPrev: function(tour) {
                            vm.$store.commit("changeActiveConfigPanel", {panel: 'general'})
                            vm.nextOrPrevStep(tour.getStep(tour.getCurrentStep() - 1))
                        }
                    },
                    {
                        element: "#ImportStylesSection",
                        content: "If you already have a styles files that has been created for the infinity store you can import it here.",
                        placement: "left auto",
                        backdropPadding: {bottom: 19},
                    },
                    {
                        element: "#GeneralStylesSection",
                        content: "Customize general styles of your store, including background, text and button colors.",
                        placement: "left auto",
                        backdropPadding: {bottom: 19},
                    },
                    {
                        element: "#MenuPanelStylesSection",
                        content: "Choose the look of the menu here. You can hide the menu items if you only want to display one page or hide the logo.",
                        placement: "left auto",
                        backdropPadding: {bottom: 19},
                    },
                    {
                        element: "#PlayerBarStylesSection",
                        content: "Choose all the colors of your player here.",
                        placement: "left auto",
                        backdropPadding: {bottom: 19},
                    },
                    {
                        element: "#ItemTileStylesSection",
                        content: "Choose the styles for your beat tile view.",
                        placement: "left auto",
                        backdropPadding: {bottom: 19},
                    },
                    {
                        element: "#ItemRowStylesSection",
                        content: "And the styles for the rows in the beat list view.",
                        placement: "left auto",
                        backdropPadding: {bottom: 19},
                    },
                    {
                        element: "#LicensesBoxesStylesSection",
                        content: "You selected a license to highlight earlier, now pick your colors. You can pick two colors to create a gradient background.",
                        placement: "left auto",
                        backdropPadding: {bottom: 19},
                    },
                    {
                        element: "#exportStylesButton",
                        content: "You can export your styles to a file. You can use them yourself for another configuration or share your theme with others.",
                        placement: "top auto",
                        backdropPadding: 5,
                        onNext: function() {
                            vm.$store.commit("changeActiveConfigPanel", {panel: 'pages'})
                            vm.scrollToElementInTour(0)
                        }
                    },
                    {
                        element: "#pagesTab",
                        content: "The pages panel is where you can manage all the pages on your store.",
                        placement: "right auto",
                        backdropPadding: {top: 10, bottom: 10, left: 40, right: 0},
                        onPrev: function(tour) {
                            vm.$store.commit("changeActiveConfigPanel", {panel: 'styles'})
                            vm.nextOrPrevStep(tour.getStep(tour.getCurrentStep() - 1))
                        }
                    },
                    {
                        element: "#firstDragPageIcon",
                        content: "Use the bars icon to drag and drop your pages to reorder their display in your menu. The first page is your home page.",
                        placement: "left auto",
                        backdropPadding: 10,
                    },
                    {
                        element: "#firstPageNameEdit",
                        content: "Change the name of your page as it appears in the menu and in the url slug.",
                        placement: "left auto",
                        backdropPadding: 10,
                    },
                    {
                        element: "#firstPageSettingsIcon",
                        content: "Click on the settings link to customize each page. Here you can change the page icon, display a hero, search bar or switch between full width or fixed width display. <p></p>There are other display options depending on the page type.",
                        placement: "left auto",
                        backdropPadding: 0,
                    },
                    {
                        element: "#addPageButton",
                        content: "Add a new page here.",
                        placement: "left auto",
                        backdropPadding: 5
                    },
                    {
                        element: "#cancelButton",
                        content: "If you make changes and then change your mind, you can use the Cancel button which will return your configuration to the settings of your last saved configuration.",
                        placement: "top auto",
                        container: ".customise-footer",
                        backdropPadding: 5
                    },
                    {
                        element: "#resetToDefaultLink",
                        content: "You can also reset your configuration to the default configuration settings which you saw when you first created a configuration.",
                        placement: "right auto",
                        backdropPadding: {top: 5, bottom: 5, left: 40, right: 5}
                    },
                    {
                        element: "#saveButton",
                        content: "When you’re done with your changes, don’t forget to save your configuration.",
                        placement: "top auto",
                        container: ".customise-footer",
                        backdropPadding: 5,
                        onNext: function(tour) {
                            vm.$store.commit("changeActiveConfigPanel", {panel: 'embed code'})
                            vm.scrollToElementInTour(0)
                        }
                    },
                    {
                        element: "#embedTab",
                        content: "In the last panel, you will find the code for embedding the store on your own site.",
                        backdropPadding: {top: 10, bottom: 10, left: 40, right: 0},
                        onPrev: function(tour) {
                            vm.$store.commit("changeActiveConfigPanel", {panel: 'pages'})
                            vm.nextOrPrevStep(tour.getStep(tour.getCurrentStep() - 1))
                        }
                    },
                    {
                        element: "#switchConfigButton",
                        content: "You can switch to another previously saved configuration here to edit it or get the embed code.",
                        placement: "right auto",
                        backdropPadding: {top: 5, bottom: 5, left: 40, right: 5}
                    },
                    {
                        element: "#newConfigButton",
                        content: "Or create a new configuration here. You can create as many different configurations as you need, so get started!",
                        placement: "right auto",
                        backdropPadding: {top: 5, bottom: 5, left: 40, right: 5}
                    }
                ]

                return steps
            }
        },
        watch: {
            'configPanelOpen'(val) {
                if (this.currentTour == 'starter') {
                    if (val) {
                        if (this.tour && this.tour.getCurrentStep() < 2) {
                            if (this.mobile) {
                                this.tour.end()
                            } else {
                                this.tour.goTo(2)
                            }
                        }
                    }

                    if (!val && this.tour.getCurrentStep() > 1) {
                        this.tour.goTo(1)
                    }
                }
            },
            '$store.state.showTour'(val) {
                if (val && !this.mobile && this.tour) {
                    this.tour.start(true)
                    this.tour.goTo(0)
                }
            }
        },
        destroyed() {
          /* Revert back the Bootstrap 3.4.1 sanitization for popover */
          $.fn.popover.Constructor.DEFAULTS.whiteList.button = undefined
        }
    }
</script>